<template>
  <div>
    <p class="distance-title">
      <i @click="$emit('cancelChose')" class="el-icon-arrow-right" style="cursor: pointer"></i>
      <span>卡派距离试算</span>
    </p>

    <div>
      <el-form :model="form" ref="form" :rules="rules" label-width="130px" :inline="false" size="normal">
        <el-form-item label="国家" prop="countryCode">
          <el-select :popper-append-to-body="false" popper-class="fixedPopper" class="formitem-content" v-model="form.countryCode"
          :loading="loadingCountryList" clearable filterable>
            <el-option
            style="width: 260px;"
            v-for="item in countryList"
            :key="item.id"
            :label="item.namec"
            :value="item.code"
          />
          </el-select>
        </el-form-item>
        <el-form-item label="起运地输入类型" prop="polType">
          <el-radio-group v-model="form.polType">
            <el-radio label="1">邮编</el-radio>
            <el-radio label="2">详细地址</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="起运地" prop="polAddress">
          <el-input class="formitem-content" :type="form.polType === '2' ? 'textarea' : 'text'" v-model="form.polAddress" rows="2" resize="none"></el-input>
        </el-form-item>
        <el-form-item label="目的地输入类型" prop="podType">
          <el-radio-group v-model="form.podType">
            <el-radio label="1">邮编</el-radio>
            <el-radio label="2">详细地址</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="目的地" prop="podAddress">
          <el-input class="formitem-content" :type="form.podType === '2' ? 'textarea' : 'text'" v-model="form.podAddress" rows="2" resize="none"></el-input>
        </el-form-item>
        <div align="center">
          <el-button style="margin-top: 20px;width: 230px" type="primary" size="default" @click="handleTrail">点击试算</el-button>
        </div>
      </el-form>

      <div v-if="result" align="center" style="margin-top: 30px; padding: 0 10px; line-height: 24px;">
        <span class="trailSuccess" v-if="resultType === 'success'">
          试算距离：{{result}}
        </span>
        <span class="trailFail" v-else-if="resultType === 'fail'">
          试算失败，{{result}}
        </span>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'distanceTrail',
  data() {
    return {
      loadingCountryList: false,
      countryList: [],
      form: {
        polType: '1',
        podType: '1'
      },
      rules: {
        countryCode: [{ required: true, message: '请选择国家' }],
        polType: [{ required: true, message: '请选择起运地输入类型' }],
        polAddress: [{ required: true, message: '请输入起运地' }],
        podType: [{ required: true, message: '请选择目的地输入类型' }],
        podAddress: [{ required: true, message: '请输入目的地' }]
      },
      result: null,
      resultType: null
    }
  },
  mounted() {
    this.getCountryList()
  },
  methods: {
    /**
     * 获取目的国列表
     */
     getCountryList(){
      this.loadingCountryList = true;
      this.axios.get('/api/filedata/findCountryAndEUCity').then( res=> {
          this.loadingCountryList = false
          const list = res.data.datas||[]
          this.countryList = list
          return res
        })
        .catch(res=>{
          this.loadingCountryList = false
        })
    },
    // /api/FBAfee/getDistanceTrialInfo 距离试算
    handleTrail() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const data = {
            ...this.form
          }
          this.resultType = null
          this.result = null
          this.axios.post('/api/FBAfee/getDistanceTrialInfo', data).then(res => {
            if (res.data.code === 200) {
              this.resultType = 'success'
              this.result = `${res.data.data.distance} KM`
            } else {
              this.resultType = 'fail'
              this.result = res.data.message
            }
          })
        }
      })

    }
  }
}
</script>

<style>
.fixedPopper {
  position: absolute !important;
  top: 35px !important;
  left: 0px !important;
}
</style>
<style lang="scss" scoped>
.formitem-content {
  width: 220px;
  /deep/ .el-input__inner {
    border: none;
  }
  /deep/ .el-textarea__inner {
    border: none;
  }
}
.distance-title {
  margin-bottom: 18px;
  padding-top: 150px;
  padding-left: 18px;
  line-height: 30px;
  font-size: 18px;
  font-weight: bold;
  i {
    font-weight: bold;
    &:hover {
      color: #FF4D01
    }
  }
}
.trailSuccess {
  font-size: 18px;
  font-weight: bold;
  color: #333333
}
.trailFail {
  font-size: 16px;
  color: #FF4D01;
}
</style>



// WEBPACK FOOTER //
// common/toolBar/distanceTrail.vue